import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Body from './Components/BodyComp/body';
import NavComp from './Components/MainComp/NavComp';
import FooterComp from './Components/MainComp/FooterComp';
import ContactUs from './Components/ContactComp/contactus';
import AboutUs from './Components/AboutComp/aboutus';
import Event from './Components/EventComp/event';
import SangaProfile from './Components/AboutComp/sangaprofile';
import WhatsAppButton from './Components/Whatsapp/WhatsAppButton';
import DhammaPada from './Components/DhammaPadaComp/dhammapada';
import Gallery from './Components/GalleryComp/gallery';
import ScrollToTop from './ScrollComp/ScrollToTop';
// import AwuruduSeason from './Components/awurudu/awurudu';

import LoadingScreen from './Components/LoadingComp/LoadingScreen';



function App() {


    const [isLoading, setIsLoading] = useState(true);
  const [hasShownLoading, setHasShownLoading] = useState(false);

  useEffect(() => {
    // Check if loading screen has been shown before (using sessionStorage)
    const loadingShown = sessionStorage.getItem('loadingShown');
    
    if (loadingShown) {
      setHasShownLoading(true);
      setIsLoading(false);
      return;
    }

    // Show loading screen for 3 seconds minimum
    const timer = setTimeout(() => {
      setIsLoading(false);
      sessionStorage.setItem('loadingShown', 'true');
    }, 3000);

    // Also hide when page is fully loaded
    window.addEventListener('load', () => {
      clearTimeout(timer);
      setIsLoading(false);
      sessionStorage.setItem('loadingShown', 'true');
    });

    return () => {
      clearTimeout(timer);
      window.removeEventListener('load', () => {});
    };
  }, []);


  return (
    <Router>
       {isLoading && !hasShownLoading && <LoadingScreen />}
      <NavComp />
        <ScrollToTop />
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/sangaprofile" element={<SangaProfile />} />
        <Route path="/event" element={<Event />} />
        <Route path="/dhammapada" element={<DhammaPada />} />
        <Route path="/gallery" element={<Gallery />} />
      
        


                    
                     
        

      </Routes>
      <FooterComp />
      <WhatsAppButton /> 
      {/* <AwuruduSeason /> */}
    </Router>
  );
}

export default App;








